'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_80570563 = {"container":"RadioButton_module_container__1e58aa0d","button":"RadioButton_module_button__1e58aa0d","active":"RadioButton_module_active__1e58aa0d","disabled":"RadioButton_module_disabled__1e58aa0d","size-36":"RadioButton_module_size36__1e58aa0d","size-44":"RadioButton_module_size44__1e58aa0d","size-52":"RadioButton_module_size52__1e58aa0d","with-border":"RadioButton_module_withBorder__1e58aa0d"};
require("../../../assets/cjs/components/RadioButton/src/RadioButton~DvxYWi1W.css");

exports.default = modules_80570563;
//# sourceMappingURL=RadioButton.module.less.js.map
